import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import balloon from './balloon.png';

class Balloon extends Component {

  constructor(props) {
    super(props);
    this.stop = false;
    this.state = { timeRemaing: 2000, positionY: 0, positionX: 0, moveX: (Math.random() * 2 - 1) / 30, moveY: (Math.random() * 2 - 1) / 30 }
  }

  componentWillMount(props) {
    this.setState({ ...this.state, positionY: this.props.positionY, positionX: this.props.positionX })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      const moveX =  (Math.random() * 2 - 1) / 30
      const moveY = (Math.random() * 2 - 1) / 30
      this.setState({ ...this.state, moveX, moveY, positionY: nextProps.positionY, positionX: nextProps.positionX })
    }
  }

  componentDidMount() {
    window.requestAnimationFrame(() => this.move());
  }

  componentWillUnmount() {
    this.stop = true;
  }

  move() {
    let { moveY, moveX, positionX, positionY } = this.state;
    if (positionY < 0 || positionY > 65) {
      moveY = -moveY;

    }
    if (positionX < 0 || positionX > 90) {
      moveX = -moveX;
    }
    this.setState({ ...this.state, moveX, moveY, positionY: this.state.positionY + moveY, positionX: this.state.positionX + moveX })
    if(this.stop !== true) {
      window.requestAnimationFrame(() => this.move());
    }
  }

  render() {
    return (
        <div
          className="balloon"
          style={{ position: 'absolute', top: this.state.positionY + '%', left: this.state.positionX + '%'}}
          onClick={this.props.onClick}
        >
          <div><img src={balloon} style={{ width: 90 }} /></div>
          <div className="text">{this.props.value}</div>
        </div>
    )
  }
}

class App extends Component {

  constructor(props) {
    super(props);
    const question1 = this.generateQuestion();
    const question2 = this.generateQuestion();
    this.state = {
      team: {
        points: 0,
        balloons: this.generateAnswers(question1),
        question: question1,
      },
      team2: {
        points: 0,
        balloons: this.generateAnswers(question2),
        question: question2,
      },
      timeRemaining: 150,
      gameStarted: false,
    }
  }

  startGame() {
    this.setState({ ...this.state, gameStarted: true, upgrade: false });
    setTimeout(() => this.tick(), 1000);
  }

  resetGame() {
    const question1 = this.generateQuestion();
    const question2 = this.generateQuestion();
    const state = {
      team: {
        points: 0,
        balloons: this.generateAnswers(question1),
        question: question1,
      },
      team2: {
        points: 0,
        balloons: this.generateAnswers(question2),
        question: question2,
      },
      timeRemaining: 150,
      gameStarted: false,
    }
    this.setState(state);
  }

  upgrade() {
    const state = { ...this.state, upgrade: true }
    this.setState(state)
  }

  tick() {
    if(this.state.timeRemaining > 0) {
      this.setState({ ...this.state, timeRemaining: this.state.timeRemaining - 1 })
      setTimeout(() => this.tick(), 1000);
    }
  }

  generateQuestion() {
    const a = Math.floor(Math.random() * 8) + 2
    const b = Math.floor(Math.random() * 8) + 2
    return { a, b }
  }

  generateAnswers(question) {
    const answers = []
    for(let i = 0; i < 7; i++) {
      const a = Math.floor(Math.random() * 8) + 2;
      const b = Math.floor(Math.random() * 8) + 2;
      const positionX = Math.floor(Math.random() * 80) + 0
      const positionY = Math.floor(Math.random() * 65) + 0
      answers.push({ value: a * b, positionX, positionY })
    }
    const positionX = Math.floor(Math.random() * 70) + 0
    const positionY = Math.floor(Math.random() * 65) + 0
    answers.push({ value: question.a * question.b, positionX, positionY })
    return answers
  }

  getTime() {
    const { timeRemaining } = this.state;
    const minutes = Math.floor(timeRemaining / 60);
    const seconds = timeRemaining % 60;
    function str_pad_left(string,pad,length) {
        return (new Array(length+1).join(pad)+string).slice(-length);
    }
    const finalTime = str_pad_left(minutes,'0',2)+':'+str_pad_left(seconds,'0',2);
    return finalTime;
  }


  balloonClick(team, answer) {
    if (team === 1) {
      const { points, balloons, question } = this.state.team
      let newPoints = 0;
      if (answer.value === question.a * question.b) {
        newPoints = points + 2;
      } else {
        newPoints = points - 1;
      }
      const newQuestion = this.generateQuestion()
      this.setState({
        ...this.state,
        team: {
          points: newPoints,
          balloons: this.generateAnswers(newQuestion),
          question: newQuestion,
        }
      })
    } else {
      const { points, balloons, question } = this.state.team2
      let newPoints = 0;
      if (answer.value === question.a * question.b) {
        newPoints = points + 2;
      } else {
        newPoints = points - 1;
      }
      const newQuestion = this.generateQuestion()
      this.setState({
        ...this.state,
        team2: {
          points: newPoints,
          balloons: this.generateAnswers(newQuestion),
          question: newQuestion,
        }
      })
    }
  }

  upgradeEmail() {
    const email = document.getElementById('emailUpgrade').value
    this.setState({ ...this.state, email: true })
  }

  render() {
    if (this.state.upgrade === true) {
      return <div className="App">
          <div className="board">
            <div className="message-background" />
            <div className="message" >
              <div className="title">Multiplication Balloon Quiz - Upgrade</div>
              <div><img src={balloon} width={'15%'} /></div>
              <div className="options">
                <div className="option">
                  <h3>Pro version</h3>
                  {
                    this.state.email === true ? <div>
                      Thank you. We will notify you as soon as PRO version is launched.
                      <div className="action" onClick={() => this.startGame() }>Play free version</div>
                    </div> :
                    <div>
                      <p>Please enter your e-mail address when PRO version is launched.<br />
                      You will receive a special discount for signing up early.</p>
                      <form action="//supercoders.us2.list-manage.com/subscribe/post?u=42d2189637b5744c75f13151e&amp;id=ddac05813d" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" noValidate>
                        <input type="email" className="form-control" name="EMAIL" id="mce-EMAIL" placeholder="E-mail Address" required={true} />
                        <input type="submit" className="action" value="Notify me" name="subscribe" id="mc-embedded-subscribe" />
                      </form>
                    </div>
                  }
                </div>
              </div>
            </div>
            <div className="team">
              <div className="header">
              </div>
              <div className="content">
              </div>
              <div className="footer">
              </div>
            </div>
            <div className="team">
              <div className="header">
              </div>
              <div className="content">
              </div>
              <div className="footer">
              </div>
            </div>
          </div>
        </div>
    }
    if (this.state.gameStarted === false) {
      return (
        <div className="App">
          <div className="board">
            <div className="message-background" />
            <div className="message" >
              <div className="title">Multiplication Balloon Quiz</div>
              <div><img src={balloon} width={'15%'} /></div>
              <div className="options">
                <div className="option">
                  <h3>Free</h3>
                  <ul>
                    <li>Themes: Balloon</li>
                    <li>Question Type: Multiplication 1-10</li>
                    <li>Price: Free</li>
                  </ul>

                  <div className="action" onClick={() => this.startGame() }>Play</div>
                </div>
                <div className="option">
                  <h3>Pro version</h3>
                  <ul>
                    <li>Themes: 4 other themes</li>
                    <li>Multiplication, Addition, Subtraction, Division</li>
                    <li>Customize timer</li>
                    <li>And many more features</li>
                    <li>Price: $7 (normally $15)</li>
                  </ul>
                  <div className="action" onClick={() => this.upgrade() }>Upgrade</div>
                </div>
              </div>
            </div>
            <div className="team">
              <div className="header">
              </div>
              <div className="content">
              </div>
              <div className="footer">
              </div>
            </div>
            <div className="team">
              <div className="header">
              </div>
              <div className="content">
              </div>
              <div className="footer">
              </div>
            </div>
          </div>
        </div>
      )
    }
    if (this.state.timeRemaining === 0) {
      const { team, team2} = this.state;
        const winningTeam = team.points > team2.points ? 1 : 2
        const winningPoints = winningTeam === 1 ? team.points : team2.points;
        let winningText = `Team ${winningTeam} won with ${winningPoints}`
        if (team.points === team2.points) {
          winningText = `It's a draw`
        }
        return <div className="App" onClick={() => this.resetGame() }>
          <div className="board">
            <div className="message-background" />
            <div className="message" >
              <div className="title">Times up!</div>
              <div><img src={balloon} width={'15%'} /></div>
              <div className="subtitle">{winningText}</div>
            </div>
            <div className="team">
              <div className="header">
              </div>
              <div className="content">
              </div>
              <div className="footer">
              </div>
            </div>
            <div className="team">
              <div className="header">
              </div>
              <div className="content">
              </div>
              <div className="footer">
              </div>
            </div>
          </div>
        </div>
    }
    return (
      <div className="App">
        <div className="board">
            <div className="team">
                <div className="header">
                    Points: {this.state.team.points}
                </div>
                <div className="content">
                  {
                    this.state.team.balloons.map((b, index) => {
                      return <Balloon {...b} onClick={() => this.balloonClick(1, b)} key={index} />
                    })
                  }
                </div>

                <div className="footer">
                    { `${this.state.team.question.a} x ${this.state.team.question.b}` }
                </div>
            </div>
            <div className="team">

                <div className="header">
                    Points: {this.state.team2.points}
                </div>
                <div className="content">
                  {
                    this.state.team2.balloons.map((b, index) => {
                      return <Balloon {...b} onClick={() => this.balloonClick(2, b)} key={index} />
                    })
                  }

                </div>
                <div className="footer">
                    { `${this.state.team2.question.a} x ${this.state.team2.question.b}` }
                </div>
            </div>
        </div>
        <div className="time-remaining">
          <span className="text">{this.getTime()}</span>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js